import { render, staticRenderFns } from "./LoanRuleCard.vue?vue&type=template&id=f5827db4&"
import script from "./LoanRuleCard.vue?vue&type=script&lang=ts&"
export * from "./LoanRuleCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports